import { useEffect } from "react";

/**
 * Injects JSON-LD structured data into the document head.
 * Sidesteps react-helmet-async's strict child-type check on <script> tags,
 * which rejects anything other than literal template strings.
 *
 * Usage:
 *   <JsonLd id="faq-schema" data={{ "@context": "https://schema.org", ... }} />
 */
const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return;
    const elementId = `jsonld-${id}`;
    let script = document.getElementById(elementId);
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = elementId;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
    return () => {
      const el = document.getElementById(elementId);
      if (el) el.remove();
    };
  }, [id, data]);
  return null;
};

export default JsonLd;
